module.exports = __webpack_public_path__ + "img/installDesktop1.301dd8da.png";